import { TwinDictionary } from '../globals/dictionary'
import useTwinTranslation from './useTwinTranslation'

export const usePlainMeasureDictionary = () => {
    const {t} = useTwinTranslation()
    const measureItems = {
        '0': t('units', 'Unidades'),
        'tn': t('tons', 'Toneladas'),
        'kg': t('kilograms', 'Kilogramos'),
        'gr': t('grams', 'Gramos'),
        'mg': t('milligrams', 'Miligramos'),
        'km': t('kilometres', 'Kilometros'),
        'm': t('meters', 'Metros'),
        'cm': t('centimeters', 'Centímetros'),
        'mm': t('millimeters', 'Milímetros'),
        'seg': t('secondsMaj', 'Segundos'),
        'min': t('minutes', 'Minutos'),
        'hrs': t('hours', 'Horas'),
        'dys': t('days', 'Días'),
        'wks': t('weeks', 'Semanas'),
        'mts': t('months', 'Meses'),
        'yrs': t('years', 'Años')
    }
    return measureItems
}

const useMeasureDictionary = () => {
    const {t} = useTwinTranslation()
    const measureItemsPlain = usePlainMeasureDictionary()
    const measureItems = [
        {
            name: t('mass', 'Masa'),
            childs: {
                'tn': { name: measureItemsPlain['tn']},
                'kg': { name: measureItemsPlain['kg'] },
                'gr': { name: measureItemsPlain['gr'] },
                'mg': { name: measureItemsPlain['mg'] },
            }
        },
        {
            name: t('longitude', 'Longitud'),
            childs: {
                'km': { name: measureItemsPlain['km'] },
                'm': { name: measureItemsPlain['m'] },
                'cm': { name: measureItemsPlain['cm'] },
                'mm': { name: measureItemsPlain['mm'] }
            }
        },
        {
            name: t('time', 'Tiempo'),
            childs: {
                'seg': { name: measureItemsPlain['seg'] },
                'min': { name: measureItemsPlain['min'] },
                'hrs': { name: measureItemsPlain['hrs'] },
                'dys': { name: measureItemsPlain['dys'] },
                'wks': { name: measureItemsPlain['wks'] },
                'mts': { name: measureItemsPlain['mts'] },
                'yrs': { name: measureItemsPlain['yrs'] },
            }
        }
    ]
    return {measureItems}
}

export const useMeasureShortsDictionary = () => {
    const {t} = useTwinTranslation()
    const measureItems: TwinDictionary = {
        '0': t('udsShort', 'Uds.'),
        'tn': t('tonsShort', 'T'),
        'kg': t('kilogramsShort', 'kg'),
        'gr': t('gramsShort', 'gr'),
        'mg': t('milligramsShort', 'mg'),
        'km': t('kilometresShort', 'km'),
        'm': t('metersShort', 'm'),
        'cm': t('centimetersShort', 'cm'),
        'mm': t('millimetersShort', 'mm'),
        'seg': t('secondsShort', 'seg'),
        'min': t('minutesShort', 'min'),
        'hrs': t('hoursShort', 'h'),
        'dys': t('daysShort', 'd'),
        'wks': t('weeksShort', 'sem'),
        'mts': t('monthsShort', 'mes'),
        'yrs': t('yearShort', 'a')
    }
    return {measureItems}
}


export default useMeasureDictionary